import { createContext } from 'react';
import { DigestDataDispatch, DigestDataState, getInitialState } from '../reducers/digests/digestDataReducer';

export const DigestDataContext = createContext<DigestDataState>(getInitialState());
export const DigestDataDispatchContext = createContext<DigestDataDispatch | null>(null);
